<app-container-transparent>

    <div flexLayout="row" style="margin-bottom: 20px;">
        <div fxFlex="60"></div>
        <div fxFlex="40" style="padding: 0;">
            <div class="test">
                <button (click)="clickNavigation((userProfile === 3) ? '/headhunter' : '/hao')" mat-button mat-raised-button color="primary" class="mfg-button-fav">
                    <mat-icon>arrow_back</mat-icon>
                </button>

                <button *ngIf="userProfile === 2" (click)="clickNavigation('/mfg')" mat-button mat-raised-button color="primary" class="mfg-button">
                    <mat-icon>key</mat-icon>
                    MFG
                </button>

                <!--<mat-form-field appearance="outline">
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput autocomplete="off">
                </mat-form-field>-->
            </div>
        </div>
    </div>

    <div fxLayout="row" *ngIf="loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <table mat-table [dataSource]="dataSource" class="mat-table cdk-table mat-elevation-z8">
        <ng-container matColumnDef="favorito">
            <th mat-header-cell  *matHeaderCellDef> <mat-icon style="color: #ed8a19">star</mat-icon> </th>
            <td mat-cell *matCellDef="let element">
                <mat-icon *ngIf="!element.favorito; else elseFav;"
                          (click)="addFavorito(element.codigo, element.pipeId); element.favorito = true;"
                          class="start-outline">star_outline</mat-icon>

                <ng-template #elseFav>
                    <mat-icon (click)="removeFavorito(element.codigo); element.favorito = false;"
                              class="start-outline" style="color: #ed8a19;">star_rate</mat-icon>
                </ng-template>
            </td>
        </ng-container>

        <ng-container matColumnDef="foto">
            <th mat-header-cell  *matHeaderCellDef> Foto </th>
            <td mat-cell *matCellDef="let element"> <!--{{element.foto}}--> - </td>
        </ng-container>

        <ng-container matColumnDef="candidato">
            <th mat-header-cell  *matHeaderCellDef> Candidato</th>
            <td mat-cell *matCellDef="let element"> {{element.candidato }} </td>
        </ng-container>

        <ng-container matColumnDef="mercado">
            <th mat-header-cell  *matHeaderCellDef> Área </th>
            <td mat-cell *matCellDef="let element"> {{element.mercado }} </td>
        </ng-container>

        <ng-container matColumnDef="cargo">
            <th mat-header-cell  *matHeaderCellDef> Função </th>
            <td mat-cell *matCellDef="let element">{{ (!!element.cargo) ? element.cargo : ' - ' }}</td>
        </ng-container>

        <ng-container matColumnDef="senioridade">
            <th mat-header-cell  *matHeaderCellDef> Nível </th>
            <td mat-cell *matCellDef="let element">{{ (!!element.senioridade) ? element.senioridade : ' - ' }}</td>
        </ng-container>

        <ng-container matColumnDef="disponibilidadeGeografica">
            <th mat-header-cell  *matHeaderCellDef> Disponibilidade </th>
            <td mat-cell *matCellDef="let element">
                {{ (!!element.disponibilidadeGeografica) ? element.disponibilidadeGeografica : ' - ' }}
            </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef> Status </th>
            <td mat-cell *matCellDef="let element">{{ (!!element.status) ? element.status : ' - ' }}</td>
        </ng-container>

        <ng-container matColumnDef="contatos" stickyEnd>
            <th mat-header-cell *matHeaderCellDef>Contatos</th>
            <td mat-cell *matCellDef="let element">
                <div fxLayout="row">
                    <div *ngFor="let info of element.contatos" style="margin-left: 2px;">
                        <img width="25" height="25" title="{{ info }}}" *ngIf="info == 'LINKEDIN'" src="assets/linkedin-in.png" />
                        <img width="25" height="25" title="{{ info }}}" *ngIf="info == 'WHATSAPP'" src="assets/whatsapp-icon-in.png" />
                        <img width="25" height="25" title="{{ info }}}" *ngIf="info == 'EMAIL'" src="assets/email-icon-in.png" />
                        <img width="25" height="25" title="{{ info }}}" *ngIf="info == 'CURRÍCULO'" src="assets/curriculo-icon-in.png" />
                    </div>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="9">Nenhum registro encontrado</td>
        </tr>
    </table>
    <div fxLayout="row" *ngIf="loading" style="margin-top: 0;">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

</app-container-transparent>
